import React, { useState } from 'react';

const LoginView = ({ onLoginSuccess, showToast }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Giriş başarısız oldu.' }));
        throw new Error(errorData.message || 'Giriş yapılamadı');
      }
      const data = await response.json();
      localStorage.setItem('token', data.token);
      // The backend now returns a full user object. Store it directly.
      localStorage.setItem('currentUser', JSON.stringify(data.user));
      onLoginSuccess();
    } catch (error) {
      showToast(error.message || 'Giriş başarısız oldu.', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-sky-700 to-sky-900 p-4">
      <div className="bg-white p-10 rounded-xl shadow-2xl w-full max-w-md transform transition-all hover:scale-105 duration-300">
        <div className="flex justify-center mb-8">
          <img
            src={process.env.PUBLIC_URL + '/monapart.jpg'}
            alt="MonApart Logo"
            className="h-40 w-auto rounded-md shadow-sm"
          />
        </div>
        <h2 className="text-3xl font-bold text-center mb-8 text-sky-800">Yönetici Girişi</h2>
        <form onSubmit={handleLogin}>
          <div className="mb-6">
            <label htmlFor="username" className="block text-sm font-semibold text-gray-700 mb-2">Kullanıcı Adı:</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition-shadow"
              required
              disabled={isLoading}
              placeholder="Kullanıcı adınızı girin"
            />
          </div>
          <div className="mb-8">
            <label htmlFor="password" className="block text-sm font-semibold text-gray-700 mb-2">Parola:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition-shadow"
              required
              disabled={isLoading}
              placeholder="Parolanızı girin"
            />
          </div>
          <button
            type="submit"
            className="w-full bg-sky-600 text-white p-3 rounded-lg hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 flex items-center justify-center disabled:opacity-70 transition-colors duration-300 text-lg font-semibold"
            disabled={isLoading}
          >
            {isLoading && <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white mr-3"></div>}
            Giriş Yap
          </button>
        </form>
      </div>
      <p className="text-center text-xs text-sky-200 mt-8">
        © {new Date().getFullYear()} MonApart Yönetim Sistemi. Tüm hakları saklıdır.
      </p>
    </div>
  );
};

export default LoginView;
